function formatDate(value) {
  let locale = 'de';

  switch (true) {
    default:
      break;

    case !!this.context && !!this.context.config && !!this.context.config.language:
      locale = this.context.config.language;
      break;

    case typeof window !== 'undefined' && !!window.swinger && !!window.swinger.config && !!window.swinger.config.language:
      locale = window.swinger.config.language;
      break;
  }

  try {
    let timestamp;
    if (value === parseInt(value, 10)) {
      timestamp = parseInt(value, 10);
    } else {
      timestamp = Date.parse(value);
    }
    const date = new Date(timestamp);

    let formatter;
    try {
      formatter = new Intl.DateTimeFormat(locale, {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      });
      return formatter.format(date);
    } catch (e) {
      try {
        date.toLocaleDateString(locale, {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
        })
      } catch (e) {
        return date.toDateString;
      }
    }
  } catch (e) {
    return value;
  }
}

module.exports = formatDate;



// WEBPACK FOOTER //
// ./src/libs/twig/format_date/index.js